export type Lang = 'ar' | 'en'

export const t = (lang: Lang, key: string): string => {
  return (translations[lang]?.[key] ?? translations['ar'][key] ?? key)
}

const translations: Record<Lang, Record<string, string>> = {
  ar: {
    // Nav
    home: 'الرئيسية',
    about: 'من نحن',
    articles: 'المقالات',
    contact: 'تواصل معنا',
    clients: 'عملاؤنا',
    toggleLight: 'الوضع المضيء',
    toggleDark: 'الوضع الداكن',
    langToggle: 'English',
    chatTitle: 'مساعد شليل',

    // Home
    heroTagline: 'خدمات لوجستية احترافية',
    heroTitle: 'شليل للخدمات اللوجستية',
    heroDesc: 'نربط مصر بالعالم عبر موانئ دمياط والإسكندرية والعين السخنة. شحن بحري، جوي، وبري بكفاءة عالية وموثوقية تامة.',
    heroBtn: 'اكتشف خدماتنا',
    heroContact: 'تواصل معنا',
    servicesTitle: 'خدماتنا',
    servicesSubtitle: 'نقدم حلولاً لوجستية متكاملة تلبي احتياجاتكم',
    fcl: 'شحن حاويات كاملة (FCL)',
    fclDesc: 'حاويات مخصصة بالكامل لشحنتك، مثالية للكميات الكبيرة مع أمان تام طوال الرحلة.',
    lcl: 'شحن حاويات جزئية (LCL)',
    lclDesc: 'شارك مساحة الحاوية مع شحنات أخرى، حل اقتصادي مثالي للكميات الصغيرة والمتوسطة.',
    containers: 'إدارة الحاويات',
    containersDesc: 'خدمات متكاملة لإدارة الحاويات، تتبع الشحنات، التخليص الجمركي، والتخزين.',
    airFreight: 'الشحن الجوي',
    airFreightDesc: 'حلول شحن جوي سريعة وآمنة للبضائع الحساسة والعاجلة إلى جميع أنحاء العالم.',
    landFreight: 'الشحن البري',
    landFreightDesc: 'خدمات الشحن البري إلى جميع محافظات مصر والدول المجاورة بأحدث أسطول الشاحنات.',
    freeZonesTitle: 'المناطق الحرة',
    freeZonesSubtitle: 'نقدم خدماتنا في أهم المناطق الحرة بمصر',
    freeZone1: 'مدينة 6 أكتوبر',
    freeZone1Desc: 'منطقة صناعية واستثمارية كبرى في محافظة الجيزة.',
    freeZone2: 'مدينة بدر',
    freeZone2Desc: 'منطقة صناعية متكاملة شرق القاهرة.',
    freeZone3: 'المنطقة الحرة العامة بالعامرية',
    freeZone3Desc: 'منطقة حرة استراتيجية غرب الإسكندرية.',
    freeZone4: 'برج العرب',
    freeZone4Desc: 'منطقة صناعية وحرة متطورة جنوب غرب الإسكندرية.',
    clientsTitle: 'عملاؤنا',
    clientsSubtitle: 'نخدم عملاء من داخل مصر وخارجها',
    clientLocal: 'عملاء داخل مصر',
    clientLocalDesc: 'نغطي جميع محافظات مصر بشبكة نقل متكاملة.',
    clientInternational: 'عملاء خارج مصر',
    clientInternationalDesc: 'نصل بعملائنا إلى الأسواق العالمية بكل احترافية.',
    portsTitle: 'موانئنا',
    portsSubtitle: 'نعمل في أهم الموانئ المصرية',
    port1: 'ميناء دمياط',
    port1Desc: 'من أكبر موانئ الحاويات في البحر المتوسط وشرق أفريقيا.',
    port2: 'ميناء الإسكندرية',
    port2Desc: 'العمود الفقري للتجارة الخارجية المصرية منذ آلاف السنين.',
    port3: 'ميناء العين السخنة',
    port3Desc: 'البوابة الاستراتيجية على البحر الأحمر وقناة السويس.',
    port4: 'ميناء سفاجا',
    port4Desc: 'ميناء استراتيجي على البحر الأحمر يخدم التجارة مع السعودية ودول الخليج.',
    port5: 'ميناء نويبع',
    port5Desc: 'المنفذ البحري الرئيسي للتجارة مع الأردن ودول المشرق العربي.',
    port6: 'ميناء العقبة',
    port6Desc: 'الميناء الأردني الرئيسي على البحر الأحمر وخليج العقبة.',
    landPortsTitle: 'المنافذ البرية',
    landPortsSubtitle: 'نغطي جميع المنافذ البرية المصرية والعربية',
    seaPortsTitle: 'الموانئ البحرية',
    seaPortsSubtitle: 'نعمل مع جميع الموانئ المصرية والعربية والعالمية',
    landPort1: 'منفذ السلوم',
    landPort1Desc: 'المنفذ البري الغربي على الحدود المصرية الليبية.',
    landPort2: 'منفذ قسطل',
    landPort2Desc: 'المنفذ البري الجنوبي على الحدود المصرية السودانية.',
    landPort3: 'المنفذ الشمالي الشرقي',
    landPort3Desc: 'المنافذ البرية على الحدود الشمالية الشرقية لمصر.',
    landPort4: 'منفذ رفح البري',
    landPort4Desc: 'المعبر البري الشمالي الشرقي الحدودي.',
    landPort5: 'ميناء نويبع البري',
    landPort5Desc: 'منفذ بري وبحري استراتيجي على خليج العقبة.',
    landPort6: 'ميناء خفاجة',
    landPort6Desc: 'ميناء استراتيجي يخدم حركة التجارة.',
    landPort7: 'الموانئ الشمالية',
    landPort7Desc: 'دمياط - الإسكندرية - بورسعيد، بوابات مصر البحرية الرئيسية.',
    landPort8: 'منطقة قناة السويس',
    landPort8Desc: 'الممر الملاحي الدولي الرابط بين الشرق والغرب.',
    landPort9: 'ميناء العقبة الأردني',
    landPort9Desc: 'الميناء الأردني الرئيسي على البحر الأحمر وخليج العقبة.',
    landPort10: 'ميناء سفاجا',
    landPort10Desc: 'ميناء استراتيجي على البحر الأحمر يخدم التجارة مع السعودية ودول الخليج.',
    whyTitle: 'لماذا شليل؟',
    why1: 'خبرة أكثر من 10 سنوات',
    why2: 'فريق متخصص ومحترف',
    why3: 'تغطية شاملة في الموانئ المصرية',
    why4: 'أسعار تنافسية',
    why5: 'متابعة على مدار الساعة',
    why6: 'تخليص جمركي سريع',

    // About
    aboutHeroTitle: 'من نحن',
    aboutHeroDesc: 'نحن شليل للخدمات اللوجستية، شريككم الموثوق في عالم الشحن والخدمات اللوجستية في مصر.',
    missionTitle: 'رسالتنا',
    missionText: 'نسعى إلى تقديم خدمات لوجستية متكاملة ومتميزة تلبي احتياجات عملائنا وتتجاوز توقعاتهم، مع الالتزام بأعلى معايير الجودة والمهنية في جميع موانئ مصر.',
    visionTitle: 'رؤيتنا',
    visionText: 'أن نكون الشريك اللوجستي الأول والمفضل في مصر والمنطقة، من خلال الابتكار المستمر وتطوير الكفاءات البشرية والتقنية.',
    valuesTitle: 'قيمنا',
    val1: 'الموثوقية',
    val1Desc: 'نلتزم بوعودنا ونحرص على تسليم شحناتكم في الوقت المحدد.',
    val2: 'الشفافية',
    val2Desc: 'نوفر معلومات واضحة ودقيقة عن حالة شحناتكم في كل وقت.',
    val3: 'الاحترافية',
    val3Desc: 'فريقنا مدرب على أعلى المستويات لضمان خدمة استثنائية.',
    val4: 'الابتكار',
    val4Desc: 'نواكب أحدث التقنيات اللوجستية لتحسين خدماتنا باستمرار.',
    teamTitle: 'فريقنا',
    statsTitle: 'أرقامنا تتحدث',
    stat1: 'سنة خبرة',
    stat2: 'عميل راضٍ',
    stat3: 'شحنة ناجحة',
    stat4: 'دولة حول العالم',

    // About
    journeyTitle: 'رحلتنا مع الشحن',
    step1Title: 'استلام الشحنة',
    step1Desc: 'نستلم بضائعك من موقعك بأمان ودقة',
    step2Title: 'التخطيط والنقل',
    step2Desc: 'نحدد أفضل مسار بري وننقل شحنتك بأسطولنا الحديث',
    step3Title: 'التوصيل النهائي',
    step3Desc: 'توصيل باب إلى باب في الوقت المحدد وبحالة ممتازة',
    contactInfoTitle: 'معلومات التواصل',
    workingHours: 'ساعات العمل',
    whatsAppTitle: 'تواصل فوري عبر واتساب',
    whatsAppDesc: 'فريق الدعم جاهز للرد على استفساراتك على مدار الساعة',
    phoneLabel: 'هاتف',
    emailLabel: 'بريد إلكتروني',
    addressLabel: 'عنوان',
    branchesTitle: 'فروعنا',
    openMap: 'افتح على الخريطة',

    // Articles
    articlesHeroTitle: 'المقالات',
    articlesHeroDesc: 'آخر الأخبار والمقالات في عالم الشحن والخدمات اللوجستية',
    readMore: 'اقرأ المزيد',
    minRead: 'دقائق قراءة',
    backToArticles: 'العودة للمقالات',
    publishedOn: 'نُشر في',
    by: 'بقلم',
    shareArticle: 'شارك المقال',

    // Contact
    contactHeroTitle: 'تواصل معنا',
    contactHeroDesc: 'نحن هنا لمساعدتك. تواصل معنا الآن واحصل على استشارة مجانية.',
    phone: 'الهاتف',
    email: 'البريد الإلكتروني',
    address: 'العنوان',
    addressVal: 'كفر الشيخ، مصر',
    emailVal: 'shelillogistics@gmail.com',
    formTitle: 'أرسل لنا رسالة',
    formName: 'الاسم الكامل',
    formEmail: 'البريد الإلكتروني',
    formPhone: 'رقم الهاتف',
    formService: 'الخدمة المطلوبة',
    formMsg: 'رسالتك',
    formSubmit: 'إرسال الرسالة',
    formSuccess: 'تم إرسال رسالتك بنجاح! سنتواصل معك قريباً.',
    selectService: 'اختر الخدمة',
    freeConsult: 'احجز استشارة مجانية',

    // Chat
    chatWelcome: 'مرحباً! أنا مساعد شليل للخدمات اللوجستية. كيف يمكنني مساعدتك؟',
    chatPlaceholder: 'اكتب رسالتك...',
    chatSend: 'إرسال',
    quickReplies: 'اختر سؤالاً سريعاً:',

    // Footer
    footerTagline: 'شريككم اللوجستي الموثوق في مصر',
    allRights: 'جميع الحقوق محفوظة',
  },
  en: {
    // Nav
    home: 'Home',
    about: 'About Us',
    articles: 'Articles',
    contact: 'Contact Us',
    clients: 'Our Clients',
    toggleLight: 'Light Mode',
    toggleDark: 'Dark Mode',
    langToggle: 'عربي',
    chatTitle: 'Shalil Assistant',

    // Home
    heroTagline: 'Professional Logistics Services',
    heroTitle: 'Shalil Logistics Services',
    heroDesc: 'Connecting Egypt to the world through Damietta, Alexandria, and Ain Sokhna ports. Sea, air, and land freight with high efficiency and full reliability.',
    heroBtn: 'Discover Our Services',
    heroContact: 'Contact Us',
    servicesTitle: 'Our Services',
    servicesSubtitle: 'We provide integrated logistics solutions tailored to your needs',
    fcl: 'Full Container Load (FCL)',
    fclDesc: 'Containers dedicated entirely to your cargo, ideal for large volumes with complete security throughout the journey.',
    lcl: 'Less than Container Load (LCL)',
    lclDesc: 'Share container space with other shipments, an economical solution ideal for small and medium quantities.',
    containers: 'Container Management',
    containersDesc: 'Integrated services for container management, shipment tracking, customs clearance, and warehousing.',
    airFreight: 'Air Freight',
    airFreightDesc: 'Fast and safe air freight solutions for sensitive and urgent goods to all parts of the world.',
    landFreight: 'Land Freight',
    landFreightDesc: 'Land freight services to all Egyptian governorates and neighboring countries with the latest truck fleet.',
    freeZonesTitle: 'Free Zones',
    freeZonesSubtitle: 'We provide our services in Egypt\'s most important free zones',
    freeZone1: '6th October City',
    freeZone1Desc: 'Major industrial and investment free zone in Giza governorate.',
    freeZone2: 'Badr City',
    freeZone2Desc: 'Integrated industrial zone east of Cairo.',
    freeZone3: 'Amreya Public Free Zone',
    freeZone3Desc: 'Strategic free zone west of Alexandria.',
    freeZone4: 'Borg El Arab',
    freeZone4Desc: 'Advanced industrial and free zone southwest of Alexandria.',
    clientsTitle: 'Our Clients',
    clientsSubtitle: 'We serve clients from within Egypt and abroad',
    clientLocal: 'Domestic Clients',
    clientLocalDesc: 'We cover all Egyptian governorates with an integrated transport network.',
    clientInternational: 'International Clients',
    clientInternationalDesc: 'We connect our clients to global markets with full professionalism.',
    portsTitle: 'Our Ports',
    portsSubtitle: 'We operate at Egypt\'s most important ports',
    port1: 'Damietta Port',
    port1Desc: 'One of the largest container ports in the Mediterranean and East Africa.',
    port2: 'Alexandria Port',
    port2Desc: 'The backbone of Egypt\'s foreign trade for thousands of years.',
    port3: 'Ain Sokhna Port',
    port3Desc: 'The strategic gateway on the Red Sea and Suez Canal.',
    port4: 'Safaga Port',
    port4Desc: 'Strategic Red Sea port serving trade with Saudi Arabia and the Gulf.',
    port5: 'Nuweiba Port',
    port5Desc: 'The main seaport for trade with Jordan and the Levant.',
    port6: 'Aqaba Port',
    port6Desc: 'Jordan\'s main port on the Red Sea and Gulf of Aqaba.',
    landPortsTitle: 'Land Ports',
    landPortsSubtitle: 'We cover all Egyptian and Arab land ports',
    seaPortsTitle: 'Sea Ports',
    seaPortsSubtitle: 'We work with all Egyptian, Arab, and international ports',
    landPort1: 'Salloum Border Crossing',
    landPort1Desc: 'The western land port on the Egyptian-Libyan border.',
    landPort2: 'Qustul Border Crossing',
    landPort2Desc: 'The southern land port on the Egyptian-Sudanese border.',
    landPort3: 'Northeastern Border',
    landPort3Desc: 'Land ports on Egypt\'s northeastern borders.',
    landPort4: 'Rafah Border Crossing',
    landPort4Desc: 'The northeastern border crossing.',
    landPort5: 'Nuweiba Land Port',
    landPort5Desc: 'Strategic land and sea port on the Gulf of Aqaba.',
    landPort6: 'Khafaga Port',
    landPort6Desc: 'Strategic port serving trade movement.',
    landPort7: 'Northern Ports',
    landPort7Desc: 'Damietta - Alexandria - Port Said, Egypt\'s main maritime gateways.',
    landPort8: 'Suez Canal Area',
    landPort8Desc: 'The international navigational corridor linking East and West.',
    landPort9: 'Jordanian Aqaba Port',
    landPort9Desc: 'Jordan\'s main port on the Red Sea and Gulf of Aqaba.',
    landPort10: 'Safaga Port',
    landPort10Desc: 'Strategic Red Sea port serving trade with Saudi Arabia and the Gulf.',
    whyTitle: 'Why Shalil?',
    why1: 'Over 10 Years of Experience',
    why2: 'Specialized Professional Team',
    why3: 'Full Coverage at Egyptian Ports',
    why4: 'Competitive Pricing',
    why5: '24/7 Follow-up',
    why6: 'Fast Customs Clearance',

    // About
    aboutHeroTitle: 'About Us',
    aboutHeroDesc: 'We are Shalil Logistics Services, your trusted partner in shipping and logistics in Egypt.',
    journeyTitle: 'Our Freight Journey',
    step1Title: 'Pickup',
    step1Desc: 'We collect your cargo from your location with safety and precision.',
    step2Title: 'Planning & Transport',
    step2Desc: 'We determine the best land route and transport your shipment with our modern fleet.',
    step3Title: 'Final Delivery',
    step3Desc: 'Door-to-door delivery on time and in excellent condition.',
    teamTitle: 'Our Team',
    contactInfoTitle: 'Contact Information',
    workingHours: 'Working Hours',
    whatsAppTitle: 'Instant WhatsApp Chat',
    whatsAppDesc: 'Our support team is ready to answer your inquiries 24/7.',
    phoneLabel: 'Phone',
    emailLabel: 'Email',
    addressLabel: 'Address',
    branchesTitle: 'Our Branches',
    openMap: 'Open on Map',
    missionTitle: 'Our Mission',
    missionText: 'We strive to provide integrated and distinguished logistics services that meet and exceed our clients\' expectations, with a commitment to the highest standards of quality and professionalism at all Egyptian ports.',
    visionTitle: 'Our Vision',
    visionText: 'To be the first and preferred logistics partner in Egypt and the region, through continuous innovation and development of human and technical capabilities.',
    valuesTitle: 'Our Values',
    val1: 'Reliability',
    val1Desc: 'We honor our commitments and ensure your shipments are delivered on time.',
    val2: 'Transparency',
    val2Desc: 'We provide clear and accurate information about your shipments at all times.',
    val3: 'Professionalism',
    val3Desc: 'Our team is trained to the highest levels to ensure exceptional service.',
    val4: 'Innovation',
    val4Desc: 'We keep up with the latest logistics technologies to continuously improve our services.',
    statsTitle: 'Our Numbers Speak',
    stat1: 'Years of Experience',
    stat2: 'Satisfied Clients',
    stat3: 'Successful Shipments',
    stat4: 'Countries Worldwide',

    // Articles
    articlesHeroTitle: 'Articles',
    articlesHeroDesc: 'Latest news and articles in the world of shipping and logistics',
    readMore: 'Read More',
    minRead: 'min read',
    backToArticles: 'Back to Articles',
    publishedOn: 'Published on',
    by: 'By',
    shareArticle: 'Share Article',

    // Contact
    contactHeroTitle: 'Contact Us',
    contactHeroDesc: 'Get a free land freight consultation. Contact us now.',
    phone: 'Phone',
    email: 'Email',
    address: 'Address',
    addressVal: 'Kafr el-Sheikh, Egypt',
    emailVal: 'shelillogistics@gmail.com',
    formTitle: 'Send Us a Message',
    formName: 'Full Name',
    formEmail: 'Email Address',
    formPhone: 'Phone Number',
    formService: 'Required Service',
    formMsg: 'Your Message',
    formSubmit: 'Send Message',
    formSuccess: 'Your message was sent successfully! We will contact you soon.',
    selectService: 'Select Service',
    freeConsult: 'Book a Free Consultation',

    // Chat
    chatWelcome: 'Hello! I am Shalil Logistics Assistant. How can I help you?',
    chatPlaceholder: 'Type your message...',
    chatSend: 'Send',
    quickReplies: 'Choose a quick question:',

    // Footer
    footerTagline: 'Your trusted logistics partner in Egypt',
    allRights: 'All rights reserved',
  },
}

export default translations
